var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-big",style:({
    width: _vm.pxToEm(_vm.width),
    height: _vm.pxToEm(_vm.height)
  }),on:{"click":function($event){return _vm.clickHandler()}}},[_c('div',{staticClass:"f-bg",style:({ height: _vm.pxToEm(_vm.height * 0.145) })}),_c('div',{style:({ 'margin-top': _vm.pxToEm(-_vm.height * 0.145), display:'flex', flex:'1 1 100%' })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }